import React from 'react';
import { ListPlus } from 'lucide-react';
import { useInviteCart } from './InviteCartProvider';
import { useAuth } from '../context/AuthContext';

/**
 * Iter-187 — Floating "Review N selected" pill anchored to the bottom
 * right of the viewport. Visible only to admins, only when the cart
 * has at least one entry. Clicking opens the cart review drawer.
 *
 * Uses a high z-index so it stays above page content + bottom nav bars
 * (mobile chrome). Honours iOS safe-area-inset.
 */
const InviteCartFloatingBar = () => {
  const { user } = useAuth();
  const { items, openReview } = useInviteCart();
  const isAdmin = (user?.role || '').toLowerCase() === 'admin';

  if (!isAdmin || items.length === 0) return null;

  return (
    <button
      type="button"
      onClick={openReview}
      className="fixed bottom-5 right-5 z-50 bg-cyan-500 hover:bg-cyan-600 text-white rounded-full shadow-2xl px-5 py-3 flex items-center gap-2 transition-transform hover:scale-105"
      style={{ paddingBottom: 'max(12px, env(safe-area-inset-bottom))' }}
      data-testid="invite-cart-floating-bar"
      aria-label={`Review Invite List with ${items.length} talent`}
    >
      <ListPlus className="w-5 h-5" />
      <span className="text-sm font-semibold">
        Review Invite List · <span data-testid="invite-cart-count">{items.length}</span>
      </span>
    </button>
  );
};

export default InviteCartFloatingBar;
